export const STOREFRONT_EXPERIENCE_FLAGS = [
  'storefront_card_hover_image',
  'storefront_fly_to_cart',
  'storefront_stagger_grid',
  'storefront_image_zoom',
  'storefront_order_confetti',
] as const

export type StorefrontExperienceFlag = typeof STOREFRONT_EXPERIENCE_FLAGS[number]

export type StorefrontHeaderStyle = 'classic' | 'compact' | 'mega'

export function parseStorefrontHeaderStyle(value?: string | null): StorefrontHeaderStyle {
  if (value === 'compact' || value === 'mega') return value
  return 'classic'
}

export function parseStorefrontFlag(value?: string | null, defaultOn = false): boolean {
  if (value == null || value === '') return defaultOn
  return value === 'true' || value === '1'
}

export function prefersReducedMotion(): boolean {
  if (!import.meta.client) return false
  return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false
}
